import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M53.04 22.011H22.019l-1.071-3.996h31.021l1.071 3.996ZM53.04 33.997H22.019l-1.071-3.996h31.021l1.071 3.996ZM53.04 46.002H22.019l-1.071-3.996h31.021l1.071 3.996ZM16.269 16.591l-5.426 1.44 1.44 5.426 5.426-1.44-1.44-5.426ZM16.537 28.566l-5.426 1.44 1.44 5.426 5.426-1.44-1.44-5.426ZM16.537 40.571l-5.426 1.44 1.44 5.426 5.426-1.44-1.44-5.426Z"
      }
    )
  }
);
export {
  t as List
};
